import axios from "axios";

const axiosClient = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("starGoldAdminToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Allow the browser to automatically set
    // multipart/form-data with the correct boundary
    // when uploading files.
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosClient;
